import BaseProxy from './Proxy';

export default class BarringProfileResellingProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/barring/profile/reselling', parameters);
  }

  status() {
    return this.submit('get', `${this.endpoint}/status`);
  }

  edit() {
    return this.submit('get', `${this.endpoint}/edit`);
  }

  write(items, pin) {
    return this.submit('post', `${this.endpoint}/write`, { items, pin });
  }
}
